module.exports = __webpack_public_path__ + "img/route.3daea132.png";